export default (http, resource, apiVersion) => ({
    getIpCountry() {
        const method = 'get';
        const url = `${resource}/${apiVersion}/get-country-from-ip`;
        return http({ method, url });
    },
    getAddressDetailsFromIp() {
        const method = 'get';
        const url = `${resource}/${apiVersion}/ip/address`;
        return http({ method, url });
    }
});
